/* Keep server-rendered recommendations visible; enhance each carousel near the viewport. */
(function () {
  if (window.slRecommendationsMounted) return;
  window.slRecommendationsMounted = true;
  var mounted = new WeakSet();
  function mount(section) {
    if (mounted.has(section)) return;
    var slider = section.querySelector('.block__best-seller-slider');
    if (!slider) return;
    mounted.add(section);
    var $ = theme.jQuery, $slider = $(slider), initialized = false;
    function init() {
      if (initialized || !slider.isConnected) return;
      initialized = true;
      $slider.slick({
        slidesToShow: 4, slidesToScroll: 1, dots: false, arrows: true,
        prevArrow: $(section).find('.block__best-seller-slider-prev'),
        nextArrow: $(section).find('.block__best-seller-slider-next'),
        responsive: [
          { breakpoint: 1199, settings: { slidesToShow: 3 } },
          { breakpoint: 749, settings: { slidesToShow: 2 } },
          { breakpoint: 575, settings: { slidesToShow: 1, centerMode: true, centerPadding: '70px' } }
        ]
      });
    }
    section.addEventListener('pointerdown', init, { once: true });
    section.addEventListener('focusin', init, { once: true });
    if ('IntersectionObserver' in window && !Shopify.designMode) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          observer.disconnect(); init();
        }
      }, { rootMargin: '1400px 0px' });
      observer.observe(section);
    } else init();
  }
  function scan(root) { root.querySelectorAll('.best-seller').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(document); }, { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
